import { memo } from 'react';
import { useCreatorDaresContext } from 'root/src/client/web/record/CreatorData/CreatorDare/creatorDares.context';
import * as Carousel from 'root/src/client/v2/common/components/Carousel/Carousel';
import Autoplay from 'embla-carousel-autoplay';
import { CreatorDareCard } from 'root/src/client/web/record/CreatorData/CreatorDare/CreatorDareCard';
import { CreatorEventFulfilledDareStatus } from 'root/src/shared/dares/creatorEventFulfilledDare.types';
import { useIsAdmin } from 'root/src/client/v2/auth/hooks/useIsAdmin';
import { useUserId } from 'root/src/client/v2/auth/hooks/useUserId';
export const CreatorDaresCarousel = memo(() => {
    const { isAdmin } = useIsAdmin();
    const { dares } = useCreatorDaresContext();
    const { userId } = useUserId();
    return (<Carousel.Root loop dragFree plugins={[Autoplay({
                delay: 5000,
                stopOnInteraction: false,
            })]}>
			<Carousel.Container className="flex -ml-4 flex-initial">
				{dares.map((dare) => {
            const isDareCreator = dare.userId === userId;
            const isVisible = dare.status === CreatorEventFulfilledDareStatus.Enabled || isDareCreator || isAdmin;
            if (!isVisible) {
                return null;
            }
            return (<div key={dare.id} className="px-4 flex-[0_0_30%] lg:flex-[0_0_25%]">
							<CreatorDareCard isDareCreator={isDareCreator} dare={dare}/>
						</div>);
        })}
			</Carousel.Container>
		</Carousel.Root>);
});
